import '.e{flex-shrink:0;}.ssr-plugin'
import '.d4{width:20rem;}.ssr-plugin'
import '.be{border:var(--border-subtle);}.ssr-plugin'
import '.bl{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.b4{border-radius:1.25rem;}.ssr-plugin'
import '.k{padding:1rem;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.a4{gap:2rem;}.ssr-plugin'
import '.d5{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="e d4 be bl b4 k"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="l a4 d5"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
